import React, { Component, useEffect, useRef, useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  SearchBox,
  Hits,
  Pagination,
  Configure
} from 'react-instantsearch-hooks-web';
import { history } from 'instantsearch.js/es/lib/routers';
let indexName = null;
let searchClient = null;

if (typeof wlAlgolia !== 'undefined') {
  const appId = wlAlgolia.application_id;
  const apiKey = wlAlgolia.search_api_key;
  indexName = wlAlgolia.indices.searchable_posts.name;
  searchClient = algoliasearch(appId, apiKey);
}

// Using items and results
const transformItems = (items, { results }) => {
  return items.map((item, index) => ({
    ...item,
    position: { index, page: results.page }
  }));
};

function Hit({ hit }) {
  return (
    <article className="card">
      <a
        href={hit.permalink}
        title={hit.post_title}
        className="search-hit module-hover-root"
        data-object-id={hit.objectID}
        data-object-position={hit.__position}
      >
        <section className="card__body">
          <h4 className="card__title">{hit.post_title}</h4>
          <p className="card__description u--margin-0">{hit.post_excerpt}</p>
        </section>
      </a>
    </article>
  );
}

const routing = {
  router: history(),
  stateMapping: {
    stateToRoute(uiState) {
      const indexUiState = uiState[indexName];
      console.log('indexUiState');
      console.log(indexUiState);
      return {
        s: indexUiState.query,
        page: indexUiState.page
      };
    },
    routeToState(routeState) {
      return {
        [indexName]: {
          query: routeState.s,
          page: routeState.page
        }
      };
    }
  }
};

export default function SiteSearch() {
  if (!searchClient) {
    return null;
  }
  
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      routing={routing}
      insights={true}
    >
      <header class="page-header page-header--primary">
        <h1 class="page-header__title u--text-align-center">Search</h1>
        <div class="page-header__search-form page-header__search-form--simple page-header__search-form--narrow u--margin-bottom-0">
          <Configure hitsPerPage={10} />
          <SearchBox
            classNames={{
              root: 'searchbox',
              submit: 'btn btn--white'
            }}
            translations={{
              submitTitle: 'Search'
            }}
            placeholder="Search"
          />
        </div>
      </header>
      <div className="search-panel">
        <div className="search-panel__results">
          <Hits hitComponent={Hit} />
          <div className="pagination">
            <Pagination />
          </div>
        </div>
      </div>
    </InstantSearch>
  );
}
